import {VStack} from 'platform/foundation';

import {ListFeatures} from '../../components/ListFeatures/ListFeatures';
import {SectionPrint} from '../../components/SectionPrint/SectionPrint';
import {Separator} from '../../components/Separator/Separator';
import {i18n} from '../../i18n/i18n';
import {HistoryCheckDataSources} from './components/HistoryCheckDataSources';
import {getHistoryChecks} from './utils/getHistoryChecks';

export function HistoryCheckPrint() {
  return (
    <SectionPrint icon="historyCheck" heading={i18n.t('historyCheck.title')}>
      <VStack spacing={10}>
        <ListFeatures
          columns={2}
          spacing={4}
          features={getHistoryChecks()}
          data-testid="historyCheckPrint"
        />
        <Separator />
        <HistoryCheckDataSources data-testid="historyCheckPrint" />
      </VStack>
    </SectionPrint>
  );
}
